export default __webpack_public_path__ + "static/media/visacard.6a2fbf98.png";